export { default as component } from "../../../../src/routes/+error.svelte";